const  getters = {
    seleccionados: state => state.seleccionados,
    masutilizados: state => state.masutilizados,
};
 
export default getters;